import { render } from "./WordCell.vue?vue&type=template&id=6e2b827e&scoped=true"
import script from "./WordCell.vue?vue&type=script&lang=js"
export * from "./WordCell.vue?vue&type=script&lang=js"

import "./WordCell.vue?vue&type=style&index=0&id=6e2b827e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2b827e"]])

export default __exports__